import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import EmailCaptureForm from "web/react/components/email-capture-form/email-capture-form";
import JSONLD from "web/react/components/json-ld/json-ld";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import requester from "web/script/modules/requester";
import userProfiler from "web/script/modules/userprofiler";
import storage from "web/script/utils/storage";
import url from "web/script/utils/url";
import styles from "./homepage-overlay.css";

function HomepageOverlay(_ref) {
  var cookiePolicyLink = _ref.cookiePolicyLink,
      privacyPolicyLink = _ref.privacyPolicyLink,
      termsAndConditionsLink = _ref.termsAndConditionsLink,
      refreshTest = _ref.refreshTest,
      signupStyle = _ref.signupStyle,
      isEU = _ref.isEU,
      signInLink = _ref.signInLink;
  var appElement = useRef(null);

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      emailAddress = _useState2[0],
      setEmailAddress = _useState2[1];

  var _useState3 = useState(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      formErrors = _useState4[0],
      setFormErrors = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      marketingEmails = _useState6[0],
      setMarketingEmails = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      overlayOpen = _useState8[0],
      setOverlayOpen = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      privacyPolicy = _useState10[0],
      setPrivacyPolicy = _useState10[1];

  useEffect(function () {
    if (storage.get("homepageOverlayShown") === true || userProfiler.getHomepageOverlayShown() === true) {
      setOverlayOpen(false);
    } else {
      analytics.event("signup_hp_wall", "open_signup_form", "open_overlay", true);

      if (!refreshTest) {
        userProfiler.setHomepageOverlayShown();
        storage.set("homepageOverlayShown", true);
      }
    }

    Modal.setAppElement(appElement.current);
  }, [refreshTest]);

  function changeEmail(event) {
    setEmailAddress(event.target.value);
  }

  function handleLegalChange(privacyPolicyChecked, marketingEmailsChecked) {
    if (privacyPolicy !== privacyPolicyChecked || marketingEmails !== marketingEmailsChecked) {
      setPrivacyPolicy(privacyPolicyChecked);
      setMarketingEmails(marketingEmailsChecked);
    }
  }

  function onSubmit(_x) {
    return _onSubmit.apply(this, arguments);
  }

  function _onSubmit() {
    _onSubmit = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(event) {
      var body, parsedURL, nextParam, jsonData, queryParams, errors;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              analytics.event("signup_hp_wall", "click_signup_button", "signup_button");
              body = {
                email: emailAddress,
                marketing_emails: marketingEmails,
                privacy_policy: privacyPolicy
              };
              parsedURL = url.parse(window.location);
              nextParam = parsedURL.path;
              jsonData = undefined;
              queryParams = url.toQueryString({
                type: "normal_hp_wall",
                next: nextParam,
                email_capture: "true"
              }).toString();
              _context.prev = 7;
              _context.next = 10;
              return requester.post("/account/register/?".concat(queryParams), body);

            case 10:
              jsonData = _context.sent;
              _context.next = 18;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](7);
              console.error(_context.t0);
              setFormErrors({
                other: [gettext("account.login.with_magic_link.error_title")]
              });
              return _context.abrupt("return");

            case 18:
              if (jsonData && jsonData.success) {
                if (refreshTest) {
                  userProfiler.setHomepageOverlayShown();
                  storage.set("homepageOverlayShown", true);
                }

                window.location = jsonData.next;
              } else {
                errors = jsonData.data.errors;
                setFormErrors(errors);
              }

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 13]]);
    }));
    return _onSubmit.apply(this, arguments);
  }

  function handleClose() {
    setOverlayOpen(false);
  }

  function onSocialClick(authProvider) {
    event.preventDefault(); // signup_facebook, signup_google

    analytics.event("signup_hp_wall", "click_social_sign_up", "signup_".concat(authProvider));

    if (privacyPolicy !== true || marketingEmails !== true) {
      setFormErrors({
        privacy_policy: [gettext("account.register.user_must_tick_both_boxes")]
      });
      return;
    }

    if (refreshTest) {
      userProfiler.setHomepageOverlayShown();
      storage.set("homepageOverlayShown", true);
    } // start with the current URL (including all query parameters)


    var parsedURL = url.parse(window.location);
    var path = parsedURL.path;
    var params = url.toQueryString(parsedURL.searchParams);
    var nextParam = "".concat(path, "?").concat(params);
    var searchTerm = parsedURL.searchParams.get("q");
    var searchGender = parsedURL.searchParams.get("gender") || parsedURL.searchParams.get("meta_gender");
    var reason = parsedURL.searchParams.get("reason");
    var type = parsedURL.searchParams.get("type"); // update the path to point to the correct auth provider

    parsedURL.path = "/social/login/".concat(authProvider, "/");
    parsedURL.searchParams.set("next", nextParam);
    parsedURL.searchParams.set("isLogin", false);
    parsedURL.searchParams.set("marketingEmails", marketingEmails);
    parsedURL.searchParams.set("reason", reason);
    parsedURL.searchParams.set("authType", type);
    parsedURL.searchParams.set("searchQuery", searchTerm);
    parsedURL.searchParams.set("searchGender", searchGender); // do the redirect

    window.location = url.unparse(parsedURL);
  }

  var title = gettext("homepage.sign_up.header_shop_thousands_brands");
  var submitText = "Continue to Lyst";
  var showSocial = ["all", "social"].includes(signupStyle);
  var hideEmail = signupStyle == "social";
  var jsonLD = {
    "@context": "https://schema.org/",
    "@type": "WebPage",
    isAccessibleForFree: "False",
    hasPart: {
      "@type": "WebPageElement",
      isAccessibleForFree: "False",
      cssSelector: ".site-wrapper"
    }
  };
  var queryParams = url.toQueryString({
    type: "normal_hp_wall"
  }).toString();
  var signInLinkProps = signInLink + "?" + queryParams;
  var closeButton = React.createElement("div", {
    className: styles.close
  }, React.createElement(CloseButton, {
    onClick: handleClose,
    className: styles.closeButton
  }));
  var form = React.createElement("div", {
    className: styles.captureForm
  }, React.createElement("div", {
    className: styles.headerImage
  }, React.createElement("div", {
    className: styles.headerTitle
  }, gettext("homepage.sign_up.welcome_title")), isEU && closeButton), React.createElement("div", {
    className: styles.contentBox
  }, React.createElement("div", {
    className: styles.header
  }, React.createElement("h3", {
    className: styles.title
  }, title)), React.createElement(EmailCaptureForm, {
    captureType: "signup_hp_wall",
    cookiePolicyLink: cookiePolicyLink,
    emailAddress: emailAddress,
    emailLabelText: gettext("account.register.return_lead.recently_viewed_items.email_label"),
    formErrors: formErrors,
    onEmailChange: changeEmail,
    onLegalChange: handleLegalChange,
    onSubmit: onSubmit,
    privacyPolicyLink: privacyPolicyLink,
    submitText: submitText,
    termsAndConditionsLink: termsAndConditionsLink,
    shortEUPolicy: true,
    hideEmail: hideEmail,
    showSocial: showSocial,
    onSocialClick: onSocialClick,
    className: styles.form,
    signInLinkProps: signInLinkProps
  })));
  return React.createElement("div", {
    id: "homepage-email-capture-overlay",
    ref: appElement
  }, React.createElement(Modal, {
    appElement: document.body,
    isOpen: overlayOpen,
    className: styles.modal,
    overlayClassName: styles.overlay
  }, form), React.createElement(JSONLD, {
    JSONLD: jsonLD
  }));
}

export default HomepageOverlay;
HomepageOverlay.propTypes = {
  cookiePolicyLink: PropTypes.string.isRequired,
  privacyPolicyLink: PropTypes.string.isRequired,
  termsAndConditionsLink: PropTypes.string.isRequired,
  refreshTest: PropTypes.bool,
  signupStyle: PropTypes.string.isRequired,
  isEU: PropTypes.bool,
  signInLink: PropTypes.string
};